<template>
  <div class="paymnet-link page-container">
    <div class="page-title">
      {{ $t('menu.payment_link') }}
    </div>
    <div class="filter-section-container">
      <div class="filter-fixed">
        <span class="filter-fixed-title">{{ $t('data.filter_section') }}</span>
        <i
          class="el-icon-arrow-down filter-fixed-arrow"
          :class="{'fiter-icon-arrow-route':!showFilterContent}"
          @click="onClickFixedArrow"
        />
      </div>
      <el-collapse-transition>
        <div v-show="showFilterContent">
          <div id="filter-content" class="filter-content">
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('payment_links.create_time') }}</div>
              <el-date-picker
                v-model="search.period"
                class="filter-item-value"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00','23:59:59']"
                type="daterange"
                range-separator="~"
                :start-placeholder="$t('components.start_date')"
                :end-placeholder="$t('components.end_date')"
              />
            </div>
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('payment_links.link_no') }}</div>
              <el-input v-model.trim="search.mch_ref_no" size="small" type="text" :placeholder="$t('payment_links.link_no')" class="filter-item-value" clearable />
            </div>
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('payment_links.active_status') }}</div>
              <el-select v-model="search.status" :placeholder="$t('payment_links.active_status')" size="small" class="filter-item-value" clearable>
                <el-option v-for="(item,index) in activeStatusMap" :key="index" :label="item.label" :value="item.value" />
              </el-select>
            </div>
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('payment_links.payment_status') }}</div>
              <el-select v-model="search.paid_status" :placeholder="$t('payment_links.payment_status')" size="small" class="filter-item-value" clearable>
                <el-option :label="$t('payment_links.paid')" :value="1" />
                <el-option :label="$t('payment_links.unpaid')" :value="2" />
              </el-select>
            </div>
            <div class="filter-operate">
              <div class="filter-operate-left">
                <el-button class="search-btn mb-10" v-if="!compIsPerCollMerchant" type="info" size="small" @click="onClickCreateBtn">{{ $t('payment_links.create_payment_link') }}</el-button>
                <!-- <el-button class="mb-10 download-btn" :loading="downloading" type="info" size="small" icon="el-icon-download" @click="onClickDowmloadBtn">{{ $t('components.download') }}</el-button> -->
              </div>
              <div class="filter-operate-right">
                <el-button class="search-btn mb-10" size="small" @click="onClickReset">{{ $t('components.clear') }}</el-button>
                <el-button class="search-btn mb-10" type="primary" size="small" icon="el-icon-search" @click="onClickSearchBtn">{{ $t('components.search') }}</el-button>
              </div>
            </div>
          </div>
        </div>
      </el-collapse-transition>
    </div>
    <div class="tableContainer">
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        style="width: 100%"
      >
        <el-table-column :label="$t('payment_links.link_id')" align="center">
          <template slot-scope="scope">
            {{ scope.row.link_no }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('payment_links.link_no')" align="center">
          <template slot-scope="scope">
            {{ scope.row.mch_ref_no }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('payment_links.title')" align="center">
          <template slot-scope="scope">
            {{ scope.row.title }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('components.amount')" min-width="86" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.link_mode===3">{{ $t('payment_links.customer_to_enter') }}</span>
            <span v-else>{{ scope.row.amount | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('payment_links.type')" min-width="88" align="center">
          <template slot-scope="scope">
            {{ getLinkTypeMapLabel(scope.row.link_type) }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('payment_links.create_time')" min-width="108" align="center">
          <template slot-scope="scope">
            {{ scope.row.create_time }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('payment_links.active_status')" align="center">
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <div slot="content">
                <span>{{ switchTips(scope.row) }}</span>
              </div>
              <el-switch
                v-model="scope.row.status"
                :active-value="1"
                :inactive-value="2"
                :disabled="isDisabled(scope.row)"
                active-color="#4FE309"
                inactive-color="#B9B9B9"
                @change="changeActive(scope.row)"
              />
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column :label="$t('payment_links.payment_status')" min-width="120" align="center">
          <template slot-scope="scope">
            <el-tag class="tag-custom" :type="scope.row.paid_count>0?'success':'info'"> {{ scope.row.paid_count>0?$t('payment_links.paid'):$t('payment_links.unpaid') }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column :label="$t('payment_links.remark')" align="center">
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <div slot="content">
                <div style="max-width: 500px;">
                  {{ scope.row.remark }}
                </div>
              </div>
              <div class="remark">
                {{ scope.row.remark }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column :label="$t('components.operation')" min-width="184" align="center">
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <div slot="content">
                <span> {{ $t('components.detail') }}</span>
              </div>
              <svg-icon class-name="icon-function" icon-class="operation-detail" @click="onClickDetailBtn(scope.row.link_no)" />
            </el-tooltip>
            <el-tooltip placement="top">
              <span slot="content">
                {{ $t('payment_links.copy_link') }}
              </span>
              <svg-icon class-name="icon-function mb-10 copy-btn" icon-class="icon-copy" :data-clipboard-text="scope.row.link_url" @click="onClickCopyBtn('.copy-btn','Link')" />
            </el-tooltip>
            <el-tooltip placement="top">
              <div slot="content">
                <span> {{ $t('payment_links.download_qr_code') }}</span>
              </div>
              <svg-icon class-name="icon-function mb-10" icon-class="file-download" @click="onClickDownloadText(scope.row.link_no)" />
            </el-tooltip>
            <el-tooltip placement="top" v-if="!compIsPerCollMerchant">
              <div slot="content">
                <span> {{ $t('components.edit') }}</span>
              </div>
              <svg-icon class-name="icon-function" icon-class="operation-edit" @click="onClickEditBtn(scope.row.link_no)" />
            </el-tooltip>
          </template>
        </el-table-column>

      </el-table>

      <div class="pagination-container">
        <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
      </div>
    </div>
  </div>
</template>

<script>
import Clipboard from 'clipboard'
import { filterEmptyAttr, download } from '@/utils/common'
import { getLinkQr, pageLink, updateLinkStatus } from '@/api/payment-link/payment-link'
// import { appointDate } from '@/utils/index'
import { activeStatusMap, linkTypeMap } from '@/utils/maps'
import { appointDate } from '@/utils'

export default {
  name: 'Payment_Link',
  components: {
    Paginator: () => import('@/views/components/Paginator')
  },
  data() {
    return {
      createTimeList: [],
      status: null,
      tableData: [],
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      downloading: false,
      creating: false,
      submiting: false,
      multipleSelection: [],
      search: {
        period: []
      },
      showFilterContent: true
    }
  },
  computed: {
    getLinkTypeMapLabel() {
      return function(value) {
        return linkTypeMap(value).label
      }
    },
    activeStatusMap() {
      return activeStatusMap()
    },
    switchTips() {
      return (row) => {
        const { expire_time, paid_count, max_limit, expires_timestamp } = row
        const expireTime = expires_timestamp
        const unPaidCount = (max_limit || 1) - paid_count
        let tips = this.$store.getters.language === 'zh' ? `剩余支付次数 ${max_limit ? unPaidCount : this.$t('payment_links.unlimited')}` : `${max_limit ? unPaidCount : this.$t('payment_links.unlimited')} payments left`
        if (max_limit && (expire_time && Date.now() >= expireTime && unPaidCount <= 0)) {
          tips = this.$t('payment_links.both_tips')
        } else if (expire_time && Date.now() >= expireTime) {
          tips = this.$t('payment_links.link_expired_tips')
        } else if (max_limit && unPaidCount <= 0) {
          tips = this.$t('payment_links.reach_payment_limit_tips')
        }
        return tips
      }
    },
    isDisabled() {
      return (row) => {
        const { expire_time, paid_count, max_limit, expires_timestamp } = row
        const expireTime = expires_timestamp
        // 计算剩余未支付次数，如果 max_limit 为 undefined 或 null，则默认为 1
        const unPaidCount = (max_limit || 1) - paid_count
        // 如果支付链接已过期且达到最大支付次数，返回 true
        if (max_limit && (expire_time && Date.now() >= expireTime && unPaidCount <= 0)) {
          return true
        // 判断支付链接是否已过期
        } else if (expire_time && Date.now() >= expireTime) {
          return true
        // 判断是否达到最大支付次数
        } else if (max_limit && unPaidCount <= 0) {
          return true
        }
        return false
      }
    },
    compIsPerCollMerchant() {
      return this.$store.state.user.isPerCollMerchant
    },
  },
  created() {
    const { status } = this.$route.params
    this.status = Number(status)
    this.onClickSearchBtn()
  },
  methods: {
    onClickSearchBtn(otherParams = {}) {
      const params = this.getParams(otherParams)
      this.listLoading = true
      pageLink(params).then(res => {
        if (res.code === 10000) {
          this.tableData = res.data.list
          this.listQuery.total = res.data.total
          this.listQuery.page = params.page ? params.page : 1
        }
      }).finally(() => {
        this.listLoading = false
      })
    },
    getParams(otherParams = {}) {
      const { period = [], ...otherSearchParams } = this.search
      const { limit } = this.listQuery
      let params = { create_start_time: period && period[0], create_end_time: period && period[1], limit, ...otherSearchParams, ...otherParams }
      params = filterEmptyAttr(params)
      return params
    },
    onClickReset() {
      this.search = {}
    },
    onClickDetailBtn(link_no) {
      this.$router.push(`/paymentLink/createEditPaymentLink?link_no=${link_no}&type=detail`)
    },
    onClickEditBtn(link_no) {
      this.$router.push(`/paymentLink/createEditPaymentLink?link_no=${link_no}&type=edit`)
    },
    onClickPaginator() {
      const { page, limit } = this.listQuery
      const params = {
        page,
        limit
      }
      this.onClickSearchBtn(params)
    },
    onClickFixedArrow() {
      this.showFilterContent = !this.showFilterContent
    },
    changeActive(row) {
      this.listLoading = true
      const { link_no, status } = row
      updateLinkStatus({ link_no, status }).finally(() => {
        this.onClickSearchBtn()
      })
    },
    onClickDownloadText(link_no) {
      getLinkQr({ link_no }).then(res => {
        const img = res.data
        if (!img) {
          return
        }
        if (this.downloading) {
          return
        }
        this.downloading = true
        const name = 'QR_Code_' + link_no
        download(img, name)
        setTimeout(() => {
          this.downloading = false
        }, 5000)
      })
    },
    onClickCopyBtn(selectClass, name) {
      const btnCopy = new Clipboard(selectClass)
      btnCopy.on('success', () => {
        this.$message.success(`Copy ${name} Successfully!`)
        btnCopy.destroy()
      })
      btnCopy.on('error', function(e) {
        btnCopy.destroy()
      })
    },
    onClickCreateBtn() {
      this.$router.push('/paymentLink/createEditPaymentLink')
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-container{
  padding: 30px;
  text-align: right;
}
.paymnet-link{
  .search-btn {
    margin-right: 10px;
  }
 .mb-10{
    margin-bottom: 10px;
  }
}
.filter-operate{
  width: 100%;
  padding-top: 16px;
}
::v-deep .el-switch.is-disabled{
   .el-switch__core{
    background-color: #B9B9B9!important;
    border-color: #B9B9B9!important;
  }
}
.tag-custom{
  border-radius: 30px;
  padding: 0 30px;
  height: 30px;
  line-height: 30px;
  border: none;
  vertical-align: middle;
  &.el-tag--info{
    color: #B45309;
    background-color: #FDE68A;
  }
  &.el-tag--success{
    color: #047857;
    background-color: #A7F3D0;
  }
}
.remark{
  // max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>
